var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47216 13.4945C9.76285 13.7852 10.2329 13.7852 10.5205 13.4945L16.4611 7.55705C16.7518 7.26636 16.7518 6.79631 16.4611 6.50871C16.1704 6.22111 15.7003 6.21802 15.4128 6.50871L10.001 11.9205L4.58609 6.50562C4.2954 6.21493 3.82535 6.21493 3.53775 6.50562C3.25015 6.79631 3.24706 7.26636 3.53775 7.55395L9.47216 13.4945Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow-bottom.19261523ec2827ae220bc26c58e4eafe.svg";
export { ForwardRef as ReactComponent };